var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdownrightHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 9,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 3C8.38298 3 3 8.38298 3 15C3 21.617 8.38298 27 15 27C21.617 27 27 21.617 27 15C27 8.38298 21.617 3 15 3ZM18.707 15.707L13.707 20.707C13.512 20.902 13.256 21 13 21C12.744 21 12.488 20.902 12.293 20.707C11.902 20.316 11.902 19.684 12.293 19.293L16.586 15L12.293 10.707C11.902 10.316 11.902 9.684 12.293 9.29302C12.684 8.90203 13.316 8.90203 13.707 9.29302L18.707 14.293C19.098 14.684 19.098 15.316 18.707 15.707Z",
    fill: "#65676A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownrightHover);
export default __webpack_public_path__ + "static/media/dropdownrightHover.7fe08fdfda0735ba2f26f55566bc4830.svg";
export { ForwardRef as ReactComponent };